import React from 'react';
import { useErrorBoundary } from 'use-error-boundary';
import errorReporter from '@app/errorReporter';
import {
  LayoutContext,
  OnboardingPreLaunchModalContext,
  OnboardingWelcomeModalContext,
  SetupBrokerageWizardModalContext,
} from 'contexts';

import CompleteFailureScreen from './CompleteFailureScreen';

const AppErrorBoundary: React.FC = props => {
  const { children } = props;
  const { chatVisibility, setChatVisibility } =
    React.useContext(LayoutContext) || {};
  const {
    visible: onboardingPreLaunchModalVisible,
    closeModal: closeOnboardingPreLaunchModal,
  } = React.useContext(OnboardingPreLaunchModalContext) || {};
  const {
    visible: onboardingWelcomeModalVisible,
    closeModal: closeOnboardingWelcomeModal,
  } = React.useContext(OnboardingWelcomeModalContext) || {};
  const {
    visible: setupBrokerageWizardModalVisible,
    closeModal: closeSetupBrokerageWizardModal,
  } = React.useContext(SetupBrokerageWizardModalContext) || {};

  const { ErrorBoundary, didCatch, error } = useErrorBoundary({
    onDidCatch: (errorObj, errorInfo) => {
      if (chatVisibility) setChatVisibility(false);
      if (onboardingPreLaunchModalVisible) closeOnboardingPreLaunchModal();
      if (onboardingWelcomeModalVisible) closeOnboardingWelcomeModal();
      if (setupBrokerageWizardModalVisible) closeSetupBrokerageWizardModal();
      errorReporter.error(
        `Unhandled error in application, user got a blank screen: ${errorObj} ${errorInfo.componentStack}`,
      );
    },
  });

  if (didCatch) {
    return <CompleteFailureScreen />;
  }
  return <ErrorBoundary>{children}</ErrorBoundary>;
};

export default AppErrorBoundary;
